import { LayoutActions } from "../../layout/actions/layoutActions";
import { ConsentValues } from "../../common/constants/Constants";
import ElstrCore from "elstr-jslib-4/dist/ElstrCore";

export const cookieBannerOptionYes = () => {
  ElstrCore.store.dispatch(LayoutActions.acceptCookies(ConsentValues.Y));
}
